import "./App.css";
import BashPrompt from "./components/BashPrompt";
import MyCard from "./components/MyCard";

function App() {
  return (
    <>
      <BashPrompt />
      <MyCard />
    </>
  );
}

export default App;
